import {
    installRegistrationSectionLoaderGlobals,
    markRegistrationFullRuntimeLoaded,
} from './loadRegistrationSections.js';
import { ensureScriptLoaded } from '../core/ScriptRetry.js';

/**
 * Loads the full classic registration runtime (assembled monolith).
 * Heavy feature scripts (hutBookingExternal, bank, stripe, …) stay variant-/interaction-gated.
 */
export async function loadLegacyRegistrationApp(): Promise<void> {
    installRegistrationSectionLoaderGlobals();
    await ensureScriptLoaded('/assets/js/shared/registrationMemberSessionAuth.js').catch(() => undefined);
    await ensureScriptLoaded('/registration/legacy/registrationApp.js');
    markRegistrationFullRuntimeLoaded();
}

export function getLegacyBootFn(): (() => Promise<void>) | null {
    const fn = (globalThis as { bootRegistrationApp?: () => Promise<void> }).bootRegistrationApp;
    return typeof fn === 'function' ? fn : null;
}
